export default __webpack_public_path__ + "img/wagggs.718bca0f.svg";